export const REQUEST_PREOPEN_MANAGER_PENDING_CLAIMS: string =
  'REQUEST_PREOPEN_MANAGER_PENDING_CLAIMS';
export const SET_PREOPEN_MANAGER_PENDING_CLAIMS: string =
  'SET_PREOPEN_MANAGER_PENDING_CLAIMS';
